export default __webpack_public_path__ + "static/media/blog-post-layout-02-img-05.c79d947a.jpg";